module.exports = __webpack_public_path__ + "static/laptop-2034bbb1b5031f7af3a7dc079a90eb74.png";